/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSettingViewModel } from '../../models/client-setting-view-model';

export interface GetClientSettings$Params {
      body?: {
'clientID'?: number;
}
}

export function GetClientSettings(http: HttpClient, rootUrl: string, params?: GetClientSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSettingViewModel>> {
  const rb = new RequestBuilder(rootUrl, GetClientSettings.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSettingViewModel>;
    })
  );
}

GetClientSettings.PATH = '/api/Clients/GetClientSettings';
